module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "订单ID"
    },
    model: {
      value: (_vm.search.orderId),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderId", $$v)
      },
      expression: "search.orderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "{\n              width": "200"
    },
    attrs: {
      "multiple": "",
      "placeholder": "订单状态",
      "clearable": ""
    },
    model: {
      value: (_vm.search.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.search, "handleStatus", $$v)
      },
      expression: "search.handleStatus"
    }
  }, _vm._l((Object.entries(_vm.handleStatusMap)), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.search.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "hotel_id", $$v)
      },
      expression: "search.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkInRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkInRange", $$v)
      },
      expression: "search.checkInRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "离店日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkOutRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkOutRange", $$v)
      },
      expression: "search.checkOutRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住人姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.guestName),
      callback: function($$v) {
        _vm.$set(_vm.search, "guestName", $$v)
      },
      expression: "search.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择渠道",
      "clearable": ""
    },
    model: {
      value: (_vm.search.from),
      callback: function($$v) {
        _vm.$set(_vm.search, "from", $$v)
      },
      expression: "search.from"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "同舟"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "代理通"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "同程"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 4,
      "label": "飞猪"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.pay),
      callback: function($$v) {
        _vm.$set(_vm.search, "pay", $$v)
      },
      expression: "search.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.search.note),
      callback: function($$v) {
        _vm.$set(_vm.search, "note", $$v)
      },
      expression: "search.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getExcel
    }
  }, [_vm._v("导出excel")])], 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("总价格:" + _vm._s(_vm.totalPrice) + ", 总利润" + _vm._s(_vm.totalCommission) + ", 总间夜数" + _vm._s(_vm.totalRoomCount) + " ")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "from",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.from]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handleStatus",
      "label": "处理状态",
      "width": "100",
      "formatter": function (row) { return _vm.getHandleStatus(row); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        (_vm.hotelMap[row.hotel_id] && _vm.hotelMap[row.hotel_id][_vm.fromNameMap[row.from] || 'tzName']) || '-' :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期,间夜",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("\n          入住日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          离店日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.stay) + "晚")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.roomCount) + "间")]), _vm._v(" "), _c('p', [_vm._v("早餐 " + _vm._s(s.row.breakfirst || 0) + " 份")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("价格 " + _vm._s(s.row.price))]), _vm._v(" "), _c('p', [_vm._v("原价 " + _vm._s(s.row.floorPrice))]), _vm._v(" "), _c('p', [_vm._v("立减 " + _vm._s(s.row.discount))]), _vm._v(" "), _c('p', [_vm._v("利润 " + _vm._s(s.row.commission))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "客户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsName",
      "label": "房型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v(_vm._s(_vm.getPay(s.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.handleStatus) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleSend(scope.$index, scope.row)
            }
          }
        }, [_vm._v("发送")]) : _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重新编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": "handleStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "订单状态",
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "handleStatus", $$v)
      },
      expression: "editForm.handleStatus"
    }
  }, _vm._l((Object.entries(_vm.handleStatusMap).filter(
    function (item) { return item[0] != -1; }
  )), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "price", $$v)
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "floorPrice", $$v)
      },
      expression: "editForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "discount", $$v)
      },
      expression: "editForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.editForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "send",
      "label": "是否发送酒店"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.send),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "send", $$v)
      },
      expression: "editForm.send"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.editForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "breakfirst", $$v)
      },
      expression: "editForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pay", $$v)
      },
      expression: "editForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.note),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "note", $$v)
      },
      expression: "editForm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.role),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "role", $$v)
      },
      expression: "addForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超级管理员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通管理员",
      "value": 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-69ebd04e"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/index.vue
// module id = 1133
// module chunks = 1